import { EventsType } from '../../../types/enums';

export const EVENT_TYPES_LABEL = {
  [EventsType.historyEvents]: 'history',
  [EventsType.upcomingEvents]: 'upcoming',
};
